<template lang="pug">
  div.row
    div.col-10
      div(v-if="isChartType || user=='esttw'")
        <ve-line :data="chartData" :y-axis="yaxis" :colors="colors"></ve-line>
      p(v-if="timeErrorFlag && isChartType" v-html="errorContext") 
      div.summary-layout
        table.table.table-fixed
          thead.thead-light
            tr
              th 地點
              th 攝影機#1時間
              th 攝影機#2時間
              th 攝影機#3時間
              th 系統時間
              th 對時結果
          tbody
            tr(v-for="data in filteredData")
              td {{ data.check_loc }}
              td {{ data.ipcam1_time}}
              td {{ data.ipcam2_time}}
              td {{ data.ipcam3_time}}
              td {{ data.check_time}}
              td {{ data.check_status}}
    div.col-2
      QueryFilter(
        v-on:filter="filter"
        :showReportButton="showReportButton"
        :showDate="showDate"
        :showStartDate="showStartDate"
        v-on:report="downloadReport"
      )
      Loader(v-if="loadingData") 
        h4 資料載入中，請稍等

  //- <div>
  //-   <!-- <div class="form-group">
  //-     <label for="">選擇系統</label>
  //-     <select name="" id="" class="form-control" v-model="selectSystem">
  //-       <option value=""> 全選 </option>
  //-       <option :value="sys.id" v-for="sys in system">{{ sys.name }}</option>
  //-     </select>
  //-   </div> -->
  //- </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import FileSaver from 'file-saver';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server, { webSocketServer } from '@/config';
import QueryFilter from './QueryFilter';
import Loader from '../../common/Loader';
import VCharts from 'v-charts'
Vue.use(VCharts)


Vue.component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  template: `
    <div>{{ rowData.employee_name }}</div>
  `,
});


export default {
  name: 'IpCamTimeLogSummary',
  data() {
    this.yaxis = {
        max: 1,
        min: 0,
        minInterval: 1,
        name: '                              (1:對時成功, 0:對時失敗)',
      }
    this.colors = ['#c23531','#00C851']
    return {
      chartData: {
          columns: ['時間', '台61彰化段北上區間起點', '台61彰化段北上區間終點'],
          rows: [],
      },
      showStartDate: true,
      showDate: false,
      showReportButton: true,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined,
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      fields: [
      ],
      server,
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: [],
      isChartType: true,
      //20200903 add
      timeErrorFlag: false,
      errorContext: '',
      /////////////////
    };
  },
  created() {
    this.clearChartData();
    this.fixed_link_code_id= this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = moment().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:',this.fixed_link_code_id);
    this.filter(this.Params);
  },
  computed: {
    user() {
      return this.$store.state.user.user.username;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  components: {
    Vuetable,
    VuetablePagination,
    QueryFilter,
    Loader,
  },
  methods: {
    clearChartData() {
      this.chartData.rows=[];
      let HStr;
      let MStr;
      for (let i=0; i<24; i++) {
        for (let j=0; j<6; j++) {
          if(i<10){
            HStr = '0'+i.toString();
          }
          else{
            HStr = i.toString(); 
          }
          if(j==0){
            MStr = '00'; 
          }
          else{
            MStr = j.toString()*10; 
          }
          let tmpStr = HStr+':'+MStr;
          //console.log('tmpStr',tmpStr);
          let tmpData = { '時間': tmpStr, '台61彰化段北上區間起點': 0, '台61彰化段北上區間終點': 0};
          this.chartData.rows.push(tmpData);
        }
      }
    },
    downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期',
        });
        return;
      }
      window.open(`${server}/download1236/download-ipcam-report/?fid=${this.$store.state.user.user.department.fixed_link_code}&start=${params.start_date}`, '_blank');
    },
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate(value) {
      return moment(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc(value) {
      if (value =='NIn'){
        return '台61彰化段北上區間起點';
      }
      else if (value =='Nout'){
        return '台61彰化段北上區間終點';
      }
    },
    filter(params) {
      if(this.loadingData==false){
          this.clearChartData();
        this.loadingData=true;
        //const filteredData = [];
        this.Params.start_date=params.start_date;
        //this.Params.end_date=params.end_date;
        ////////////////
        //while (this.filteredData.length>0) {
        //  this.filteredData.pop();
        //}
        this.filteredData = [];
        console.log('fields:',this.fields);
        var t = moment(params.start_date).format("YYYY-MM-DD");
        console.log(parseInt(moment(t).format("YYYYMMDD"),10));
        if (parseInt(moment(t).format("YYYYMMDD"),10)<20200811) {
          this.isChartType = false;
          console.log('aaa');
        }
        else {
          this.isChartType = true;
          console.log('bbb');
        }
        console.log('fields:',this.fields);
        ///////////////////
        this.instance.get(`${server}/api/ipcam-time-log/`, {
          params: {
            start_date: this.Params.start_date,
            //end_date: this.Params.end_date,
            fixed_link_code_id: this.fixed_link_code_id,
          },
        })
        .then((res) => {
          console.log(res);
          res.data.forEach((item) => {
            item.check_loc = this.readableDate_loc(item.check_loc);
            item.check_time = this.readableDate(item.check_time);
            item.ipcam1_time = this.readableDate(item.ipcam1_time);
            item.ipcam2_time = this.readableDate(item.ipcam2_time);
            item.ipcam3_time = this.readableDate(item.ipcam3_time);
            this.filteredData.push(item);
            /////////////////////
            let Hdata = parseInt(item.check_time.substring(9,11),10);
            let Mdata = parseInt(item.check_time.substring(12,14),10);
            let index = Hdata*6+Math.floor(Mdata/10);
            //console.log('index:',item.check_time,Hdata,Mdata,index);
            this.chartData.rows[index][item.check_loc]=1;
            /////////////////////
          });
          //this.$refs.vuetable.setData(filteredData);
          this.loadingData=false;
          ////////
          let checkIndex=24*6;
          if(moment(params.start_date).format("YYYY-MM-DD")==moment().format("YYYY-MM-DD")){
            const hourNow = moment().hour();
            checkIndex = hourNow*6;
          }
          //20200903 add
          this.timeErrorFlag = false;
          this.errorContext = '';
          for(let i=0; i<checkIndex; i++){
            if(this.chartData.rows[i]['台61彰化段北上區間起點']==0 ||this.chartData.rows[i]['台61彰化段北上區間終點']==0){
              this.timeErrorFlag = true;
              if(this.chartData.rows[i]['台61彰化段北上區間起點']==0){
                this.errorContext += `<strong><p>起點異常: ${this.chartData.rows[i]['時間']}</p></strong>`;
              }
              if(this.chartData.rows[i]['台61彰化段北上區間終點']==0){
                this.errorContext += `<strong><p>終點異常: ${this.chartData.rows[i]['時間']}</p></strong>`;
              }
              //this.$store.commit('SET_MESSAGE', {
              // type: 'error',
              //  context: '攝影機對時異常，請注意!',
              //});
            }
          }
          console.log('this.timeErrorFlag:',this.timeErrorFlag);
          ////////
        })
        .catch((err) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '無法取得校時資料',
          });
          this.loadingData=false;
        });
      }
    },
    connectWebSocket() {
      return new Promise((resolve, rejects) => {
        const wb = new WebSocket(`${webSocketServer}/download-report/${this.$store.state.user.user.id}`);
        wb.onopen = () => {
          this.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = (res) => {
          const data = JSON.parse(res.data);
          if (data.error) {
            this.$store.commit('CLOSE_MESSAGE');
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error,
            });
          }

          if (data.progress !== undefined) {
            this.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            this.instance.get(data.download_path, { responseType: 'blob' })
            .then((res) => {
              FileSaver.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功',
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = () => { rejects(wb); };
      });
    },
    report(params) {
      params.function_name = 'export_event_table';
      this.connectWebSocket().then((ws) => {
        ws.send(JSON.stringify(params));
      })
      .catch((ws) => {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    },
  },
  watch: {
    downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: `
        <h6>產生報告中</h6>
        <div class="progress">
          <div class="progress-bar progress-bar-striped" 
            role="progressbar" 
            style="width: ${val}%; background-color: #117a8b" 
            aria-valuenow="${val}" 
            aria-valuemin="0" 
            aria-valuemax="100">
          </div>
        </div>
        `,
        type: 'clean',
        confirm: false,
      });
    },
  },
};
</script>

<style lang="sass">
.page-active
  background-color: #0056b3
  color: white !important
  &:hover
    background-color: #0056b3

</style>



// WEBPACK FOOTER //
// IpCamTimeLogSummary.vue?16a062a2